import React from 'react';
import Scanner from '../../assets/scan.PNG';
import Gym from '../../assets/gym.PNG';
import Dashboard from '../../assets/dashboard.PNG';
// import Scanner from '../../assets/scan.PNG';
import Movies from '../../assets/movies.PNG';
import Map from '../../assets/map.PNG';
import AdminDash from '../../assets/adminDash.png';

import './Portfolio.css';


const data = [
	{
		id: '1',
		image: Scanner,
		title: 'Vulnerability Scanner Website ',
		github: '',
		demo: 'https://scannermv5.netlify.app/'
	},
	{
		id: '2',
		image: Gym,
		title: 'Fitness Gym',
		github: 'https://github.com/mahmoudsabry12/FitnessGym',
		demo: 'https://fitnessgim.pages.dev/'
	},
	{
		id: '3',
		image: Dashboard,
		title: 'Dashboard Controlling',
		github: 'https://github.com/mahmoudsabry12/Dashboard',
		demo: 'https://mahmoudsabry12.github.io/Dashboard/'
	},
	{
		id: '4',
		image: Dashboard,
		title: 'Quran Player',
		github: 'https://github.com/mahmoudsabry12/Quran_Player',
		demo: 'https://mahmoudsabry12.github.io/Quran_Player/'
	},
	{
		id: '5',
		image: Movies,
		title: 'Movies Website',
		github: 'https://github.com/mahmoudsabry12/Movies',
		demo: 'https://mahmoudsabry12.github.io/Movies/'
	},
	{
		id: '6',
		image: Map,
		title: 'Map ',
		github: 'https://github.com/mahmoudsabry12/Map',
		demo: ''
	},
	{
		id: '7',
		image: AdminDash,
		title: 'Interactive Admin Dashboard ',
		github: 'https://github.com/mahmoudsabry12/Admin_Dashboard',
		demo: 'https://admindashboard25.netlify.app/'
	},
];

const Portfolio = () => {
	return (
		<section id='portfolio'>
			<h5>My Recent Work</h5>
			<h2>Portfolio</h2>

			<div className='container portfolio__container'>
				{data.map(({ id, image, title, github, demo }) => {
					return (
						<article key={id} className='portfolio__item'>
							<div className='portfolio__item-image'>
								<img src={image} alt='portfolio' />
							</div>
							<h3>{title}</h3>
							<div className='portfolio__item-cta'>
								{github ? <a
									href={github}
									target='_blank'
									rel='noopener noreferrer'
									className='btn'
								>
									Github
								</a>
								:
								<a
									// href={github}
									target='_blank'
									rel='noopener noreferrer'
									className='btn'
									style={{backgroundColor:"gray", color:'White'}}
								>
									No Github
								</a> }
								<a
									href={demo}
									target='_blank'
									rel='noopener noreferrer'
									className='btn btn-primary'
								>
									Live Demo
								</a>
							</div>
						</article>
					);
				})}
			</div>
		</section>
	);
};

export default Portfolio;
